import Auth from './Auth'
import AuthButton from './AuthButton'
import AuthSwitch from './AuthSwitch'
import AuthIcon from './AuthIcon'
import AuthTextButton from './AuthTextButton';

Auth.AuthButton = AuthButton
Auth.AuthSwitch = AuthSwitch
Auth.AuthIcon = AuthIcon
Auth.AuthTextButton = AuthTextButton

export {
    Auth,
    AuthButton,
    AuthSwitch,
    AuthIcon,
    AuthTextButton
}

export default Auth